import { isImage, isVideo, isDocument } from 'utilities/file';

class TaskInterfaces {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/tasks`;
    this.apiClient = apiClient;

  }

  async setupOnetimeTask(task) {

    const path = `${this.basePath}/onetime`;

    return this.apiClient.post(path, {}, {}, task);

  }

  async setupRecurringTask(task) {

    const path = `${this.basePath}/recurring`;

    return this.apiClient.post(path, {}, {}, task);

  }

  async createFileForNewTask(file) {

    let path = `${this.basePath}`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  async updateTaskFacade(taskId, payload) {

    const path = `${this.basePath}/:taskId`;

    return this.apiClient.put(path, { taskId }, {}, payload);

  }

  async createFileForExistingTask(taskId, file) {

    let path = `${this.basePath}/:taskId`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, { taskId }, {}, data, true, false);

  }

  async updateTaskStatusById(taskId, status) {

    const path = `${this.basePath}/:taskId/status`;

    return this.apiClient.put(path, { taskId }, {}, { status });

  }

  async updateReminders(taskId, payload) {

    const path = `${this.basePath}/:taskId/reminders`;

    return this.apiClient.post(path, { taskId }, {}, payload);

  }

  async assignTask(taskId, assigneeId) {

    const path = `${this.basePath}/:taskId/assignees/:assigneeId`;

    return this.apiClient.put(path, { taskId, assigneeId }, {}, {});

  }

  async unassignTask(taskId) {

    const path = `${this.basePath}/:taskId/unassign`;

    return this.apiClient.delete(path, { taskId }, {}, {});

  }

  async unassignUpcomingTasks(taskId) {

    const path = `${this.basePath}/:taskId/unassign-upcoming`;

    return this.apiClient.delete(path, { taskId }, {}, {});

  }

  async deleteTask(taskId) {

    const path = `${this.basePath}/:taskId`;

    return this.apiClient.delete(path, { taskId }, {}, {});

  }

  async deleteAllTasks(taskId) {

    const path = `${this.basePath}/:taskId/upcoming`;

    return this.apiClient.delete(path, { taskId }, {}, {});

  }

  async getPaginatedTaskHistoryEntries(taskId, queryOptions) {

    const path = `${this.basePath}/:taskId/history-entries`;

    return this.apiClient.get(path, { taskId }, queryOptions);

  }

  async getTaskHistoryEntryById(taskId, historyEntryId, projection) {

    const path = `${this.basePath}/:taskId/history-entries/:historyEntryId`;

    return this.apiClient.get(path, { taskId, historyEntryId }, { projection });

  }

}

export default TaskInterfaces;